import React from 'react';
import { Link } from 'react-router-dom'
import './ArticleCard.css';
import 'aos/dist/aos.css';
import CardTag from './CardTag';
import { BASE_URL } from '../constants';
import { postfixImageWidth, stringToUrl } from '../util';

const ArticleCard = ({post, onClick}) => {
    // console.log(post);
    // console.log("Article Card");
    // console.log(typeof post.date)

    const date = new Date(post.date)
    const formattedDate = date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    });

    const handleClick = () => {
        onClick(stringToUrl(post.title)); // Pass the _id to the onClick function
    };

  return (
    <div className='' onClick={handleClick}>
    <Link to={`/blog/post/${stringToUrl(post.title)}`} className='blog-link' data-aos="fade-right">
        <div className='article-card'>
            <div className='article-card_image-box'>
                <img src={`${BASE_URL}${postfixImageWidth(post.thumbnail,"1200")}`} className="article-card_image" alt="article image"/>
            </div>
            <div className="card-body">
                <h5 className="article-card_date">{formattedDate}</h5>
                <h5 className="article-card_title">{post.title}</h5>
                <hr/>
                <p className="article-card_text">{post.subtitle}</p>
                <CardTag category={post.category}/>
            </div>
        </div>
    </Link>
    </div>
  )
}

export default ArticleCard